import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { hasMasterSession } from '../../utils/authSession';

function RequireAuth({ children }) {
  const userData = useSelector((state) => state.loginToken);
  const agentData = useSelector((state) => state.loginTokenCoUser);

  const isUserDataValid = hasMasterSession(userData);
  const isAgentDataValid = agentData?.response?.token;

  const shouldRenderChildren = useMemo(() => {
    return isUserDataValid || isAgentDataValid;
  }, [isUserDataValid, isAgentDataValid]);

  if (!shouldRenderChildren) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default RequireAuth;
